import { render, staticRenderFns } from "./UpdateNameForm.vue?vue&type=template&id=edcb03ba"
import script from "./UpdateNameForm.vue?vue&type=script&lang=ts"
export * from "./UpdateNameForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports